module.exports = __webpack_public_path__ + "img/obj_santaHat.0364cea.webp";